import { render, staticRenderFns } from "./Frontale.vue?vue&type=template&id=05cba476&"
import script from "./Frontale.vue?vue&type=script&lang=js&"
export * from "./Frontale.vue?vue&type=script&lang=js&"
import style0 from "./Frontale.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports